import { Link } from "react-router-dom";

function BoardsPage() {
	return (<h1>자유 게시판 (To <Link to="/">Home</Link>)</h1>);
}

export default BoardsPage;
